<template>

  <div v-if="isTowerSupplierCo() || canAccess('project|maintenance|management|admin')">

    <el-row style="padding-top: 1.24em;">
      <el-col :span="20">
        <h3><i class="fa fa-sitemap" />&nbsp;Site Structure</h3>
      </el-col>
      <el-col :span="3" align="right">
        <structure-action v-if="(isTowerSupplierCo() || isManager('project|maintenance')) && (rowData.status !== 'Active' || structures.length === 0)" :heading="'Add Structure: ' + rowData.siteName" :site-id="rowData.id"  @update="updated" :read-only="readOnly" />
      </el-col>
    </el-row>

    <div v-if="loading">
      <center><span class="fa fa-spinner fa-spin" /></center>
    </div>
    <div v-else>

      <div v-if="structures.length >= 1">

        <div v-if="structures.length == 1">
          <struct-details :row-data="structures[0]" :index="0" :site-id="rowData.id" @update="updated"  @delete="onDelete" :read-only="readOnly" />
        </div>

        <div v-if="structures.length > 1" >
          <el-collapse accordion>
            <el-collapse-item v-for="(s, i) in structures" :key="s.id" :title="s.name">
              <struct-details :row-data="s" :site-id="rowData.id" :index="i"  @update="updated"  @delete="onDelete" :read-only="readOnly" />
            </el-collapse-item>
          </el-collapse>
        </div>

      </div>

      <div v-else>
        <center>
          <i>No structure information found</i>
        </center>
        <br />
      </div>

    </div>

  </div>

</template>


<script>

import StructDetails from '@/components/tables/details/StructDetails'
import StructureAction from '@/components/actions/StructureAction'

import SiteMixins from '@/mixins/SiteMixins'

export default {

  mixins: [SiteMixins],

  components: {
    StructDetails,
    StructureAction
  },

  props: {

    rowData: {
      type: Object,
      required: true
    },

    editable: {
      type: Boolean,
      default: false
    },

    readOnly: {
      type: Boolean,
      default: false
    }

  },

  methods: {

    updated (i, data, adding = false) {

      if (adding) {

        this.structures.push(data)

      } else {

        if (i > -1) {
          this.structures[i] = data
        }

      }

    },


    onDelete (i, data) {

      if (i > -1) {
        this.structures.splice(i, 1)
      }

    },

    fetchStructs (structs) {
      this.loading = false
      this.structures = structs
    },

    errorStructs (err) {
      this.loading = false
      console.err(err)
    }
  },

  data () {
    return {
      loading: true,
      structures: []
    }
  },

  mounted () {
    this.findSiteStructures(this.rowData.id, this.fetchStructs, this.errorStructs)
  }

}

</script>



// WEBPACK FOOTER //
// SiteStruct.vue?759da1bc